import { setItem as setSessionItem, getItem as getSessionItem, removeItem } from 'Helpers/sessionStorage';
import { EMI_SELECTED_ADS } from 'Constants/items';
import { PRICE_CARD_TABS, PAYMENT_FREQUENCY, SHOW_PRICE_CARD_TABS } from 'Constants/priceCardTabs';

/** Return ad IDs representing the ads with the EMI tab selected */
export const getEmiSelectedAds = () => {
    return JSON.parse(getSessionItem(EMI_SELECTED_ADS) || null) || {};
};

/** Checks if the EMI option is selected for a specific ad */
export const isAdEmiSelected = adId => {
    const sessionKey = String(adId);
    const emiSelectedAds = getEmiSelectedAds();

    return !!emiSelectedAds[sessionKey];
};

/** Updates the list of ads with the EMI option selected */
export const updateEmiSelectedAds = (adId, emiData, downPayment) => {
    const sessionKey = String(adId);
    const emiSelectedAds = getEmiSelectedAds();

    if (emiSelectedAds[sessionKey]) {
        delete emiSelectedAds[sessionKey];

        setSessionItem(EMI_SELECTED_ADS, JSON.stringify(emiSelectedAds));
    }
    else {
        const payload = {
            [sessionKey]: {
                amt: emiData?.emi,
                nop: emiData?.repaymentPeriodCount,
                dp: downPayment || null
            }
        };

        setSessionItem(EMI_SELECTED_ADS, JSON.stringify({
            ...emiSelectedAds,
            ...payload
        }));
    }
};

/** Removes the specified adId from storage once the lead has been created. */
export const removeEmiSelectedAd = adId => {
    if (isAdEmiSelected(adId)) {
        const emiSelectedAds = getEmiSelectedAds();

        delete emiSelectedAds[`${adId}`];
        setSessionItem(EMI_SELECTED_ADS, JSON.stringify(emiSelectedAds));
    }
};

export const getTrackingAttributes = adId => {
    const { FULL_PRICE, EMI } = PRICE_CARD_TABS;
    const sessionKey = String(adId);
    const emiSelectedAds = getEmiSelectedAds();

    if (!getSessionItem(SHOW_PRICE_CARD_TABS)) {
        return null;
    }

    if (emiSelectedAds[sessionKey]) {
        const data = emiSelectedAds[sessionKey];

        return {
            item_down_payment: data?.dp || null,
            item_emi_amount: data?.amt || null,
            item_loan_duration: data?.nop || null,
            variants_shown: EMI
        };
    }
    return { variants_shown: FULL_PRICE };
};

export const getEmiDetails = adId => {
    if (adId && isAdEmiSelected(adId)) {
        const sessionKey = String(adId);
        const emiSelectedAds = getEmiSelectedAds();
        const data = emiSelectedAds[sessionKey];

        return {
            financeData: {
                installmentInfo: {
                    emiAmount: data?.amt,
                    frequency: PAYMENT_FREQUENCY,
                    noOfPayments: data?.nop
                },
                ...(data?.dp ? { totalDownPayment: data?.dp } : {})
            }
        };
    }
    return null;
};

export const clearEmiSelectedAdsFromStorage = () => {
    removeItem(EMI_SELECTED_ADS);
};
